module.exports = __webpack_public_path__ + "media/vraag_7_antwoord.81b643b7.mp3";